import React, { Component } from 'react';
import axios from 'axios';
import ReactPixel from 'react-facebook-pixel';

import DemoRequestForm from '../DemoRequestForm';

class DemoRequestFormContainer extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      formSubmitted: false,
    };
  }

  handleSubmit(values) {
    ReactPixel.track('Lead');
    axios
      .post(`${process.env.GATSBY_API_URL}/demo_requests`, { demo_request: values })
      .then(() => {
        this.setState({ formSubmitted: true });
      });
  }

  render() {
    const { formSubmitted } = this.state;

    return (
      <DemoRequestForm
        onSubmit={this.handleSubmit}
        submitted={formSubmitted}
      />
    );
  }
}

export default DemoRequestFormContainer;



// WEBPACK FOOTER //
// ./src/components/containers/DemoRequestFormContainer.js